import bookingActivitiesPopup from '../bookingActivitiesPopup.html';

angular.module('cfn').directive('ownActivitiesIcons', [
  'bookingActivitiesService',
  'bookingRules',
  function(bookingActivitiesService, bookingRules) {
    return {
      restrict: 'E',
      replace: false,
      scope: {
        ownActivities: '@',
        selected: '=',
        icon: '=',
        name: '=',
        section: '=',
        state: '='
      },
      templateUrl: require('./ownActivitiesIcons.html'),
      controller: [
        '$scope',
        function($scope) {
          $scope.model = {
            overitem: null,
            activities: [
              bookingRules.field.activities.TILLING,
              bookingRules.field.activities.SOWING,
              bookingRules.field.activities.SUPPLY,
              bookingRules.field.activities.CULTIVATE,
              bookingRules.field.activities.HARVESTING
            ],
            loading: true
          };

          $scope.bookingActivitiesPopup = bookingActivitiesPopup;

          $scope.reset = function() {
            bookingActivitiesService.reset();
          };

          $scope.select = function(item) {
            if ($scope.state !== 'TEMPLATE') {
              if (item) {
                $scope.selected = item.id;
                //$scope.name = item.name;
                $scope.icon = item.icon;
              } else $scope.selected = item;
            }
          };

          $scope.$on('reloadActivities', function() {
            bookingActivitiesService.query().then(function(ownActivities) {
              sortActivities(ownActivities);
              $scope.items = ownActivities;
            });
          });

          bookingActivitiesService.query().then(function(ownActivities) {
            $scope.model.loading = false;
            sortActivities(ownActivities);
            $scope.items = ownActivities;
            $scope.items.forEach(function(item) {
              if (item.id === $scope.selected) {
                $scope.select(item);
                return;
              }
            });
          });

          $scope.onActivitiesCheckboxChange = function(newActiveActivity) {
            //if user checked a checkbox
            if (newActiveActivity.active) {
              bookingRules.checkAndAddActiveActivity(
                $scope.section,
                newActiveActivity.name
              );
            } else {
              //if user unchecked a checkbox
              bookingRules.buildActiveElements($scope.section);
            }
          };
          
          function sortActivities(activities){
            if(activities) {
              activities.sort((template1, template2) => template1.name.localeCompare(template2.name));
            }
          }
        }
      ]
    };
  }
]);
